import { useEffect } from "react";

// Adds .in-view to any element with [data-reveal] when it enters the viewport.
export function useReveal(deps = []) {
  useEffect(() => {
    const els = document.querySelectorAll("[data-reveal]:not(.in-view)");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

// Animated counter using rAF. Returns nothing; call with a ref element.
export function animateCount(el) {
  const target = parseInt(el.getAttribute("data-count"), 10);
  const suffix = el.getAttribute("data-suffix") || "";
  const isYear = el.getAttribute("data-format") === "year";
  const duration = 1400;
  const start = performance.now();
  function tick(now) {
    const p = Math.min((now - start) / duration, 1);
    const eased = 1 - Math.pow(1 - p, 3);
    const val = Math.floor(target * eased);
    el.textContent = (isYear ? val : val.toLocaleString()) + (p >= 1 ? suffix : isYear ? "" : suffix);
    if (p < 1) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}
